import Store from '../stores/store';
import {MessageProvider} from '../i18n/i18n';
import {RemoteStorage} from '../storage/RemoteStorage';
import VersionKeeper from '../info/VersionKeeper';
import {RouterStore} from 'mobx-react-router';
import UrlStore from '../stores/UrlStore';

export const bootStore = (i18n: MessageProvider, routerStore: RouterStore): Store => {
    return new Store(i18n, new RemoteStorage(), new VersionKeeper(), new UrlStore(routerStore));
};



// WEBPACK FOOTER //
// ./src/boot/store.ts